export default __webpack_public_path__ + "static/media/error.2a3ce432.gif";